import { Transition } from '@headlessui/react'
import { Card } from '@radix-ui/themes'
import { Link } from '@remix-run/react'
import { useEffect, useState } from 'react'

type Props = {
	names?: string
	count?: number
}

export default function DidYouKnow(props: Props) {
	const [sample, setSample] = useState(samples[0])
	// const [open, setOpen] = useState(true)

	// useEffect(() => {
	// 	const id = setInterval(() => {
	// 		const randomInt = Math.ceil(Math.random() * 3) - 1
	// 		setSample(samples[randomInt])
	// 		// setOpen(prevState => !prevState)
	// 	}, 15000)
	// 	return () => clearInterval(id)
	// }, [])

	const transitionStyle = 'text-yellow-400'

	return (
		<Card className="w-full">
			<div className="text-h5">Did you know...</div>
			<div>
				That a <span className={transitionStyle}>{sample.sex0}</span> in the{' '}
				<span className={transitionStyle}>{sample.ageClass0}</span> age group running{' '}
				<span className={transitionStyle}>{sample.time0}</span> is less impressive than a{' '}
				<span className={transitionStyle}>{sample.sex1}</span> in the{' '}
				<span className={transitionStyle}>{sample.ageClass1}</span> age group running{' '}
				<span className={transitionStyle}>{sample.time1}?</span>
			</div>
			<div className="pt-2">
				This places the male competitor in the top{' '}
				<span className={transitionStyle}>{sample.percentile0}</span> percentile, yet the female
				competitor is in the top <span className={transitionStyle}>{sample.percentile1}</span>{' '}
				percentile (age and sex adjusted).
			</div>
			<div className="py-4 text-center text-xl">
				<Link to="/select/submit" className="bold text-pink-400 underline">
					See How a Given Time Stacks Up
				</Link>
			</div>
		</Card>
	)
}

type Sample = {
	ageClass0: string
	sex0: 'male' | 'female'
	time0: string
	percentile0: string
	ageClass1: string
	sex1: 'male' | 'female'
	time1: string
	percentile1: string
}
const samples: Array<Sample> = [
	{
		ageClass0: '18-39',
		sex0: 'male',
		time0: '02:50:00',
		percentile0: '73rd',
		ageClass1: '45-49',
		sex1: 'female',
		time1: '3:10:00',
		percentile1: '77th',
	},
]
